import { ChartBinSize, ChartDataMode, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { SPOT_FILL_RATE_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const VENDING_RECYCLE_SPOT_FILL_RATE_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.VENDING_RECYCLE_SPOT_FILL_RATE_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: SPOT_FILL_RATE_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.VENDING },
        { key: ChartQueryParam.FEATURE, value: Feature.RECYCLE_TRANSACTION },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY },
        { key: ChartQueryParam.DATA_MODE, value: ChartDataMode.PERCENTAGE }
    ]
};
